import axios from "axios";

const API = axios.create({
  baseURL: `${process.env.REACT_APP_SOCKET_URL}/api/admin`, // adjust to your backend route
});

// 🚨 Block all drivers
export async function blockAllDrivers() {
  try {
    const res = await API.post("/drivers/block", {}, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}

// ✅ Activate all drivers
export async function activateAllDrivers() {
  try {
    const res = await API.post("/drivers/activate", {}, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}

// 🔄 Toggle emergency state (optional single API)
export async function setEmergencyState(state) {
  try {
    const res = await API.post("/drivers/emergency", { state }, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}
